// All comments in English.
import axios, { AxiosError } from "axios";

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 20000,
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface ApiError {
  code?: string;
  status?: number;
  message: string;
  details?: unknown;
}

http.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    const apiError: ApiError = {
      status: err.response?.status,
      message:
        (err.response?.data as any)?.message ||
        err.message ||
        "Unknown error",
      details: (err.response?.data as any) ?? undefined,
    };
    if (apiError.status === 401) {
      localStorage.removeItem("access_token");
      // Optional: redirect to login
      // window.location.href = "/login";
    }
    return Promise.reject(apiError);
  }
);
